import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";

import CustomModal from "../Bar/CustomModal";
import CustomModalBlockUser from "../Bar/CustomModalBlockUser";
import Pagination from "../Bar/Pagination";
import API from "../../config/api";
import { exportToExcel } from "../Helper/exportToExcel";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import img1 from "../../assets/assets_theme/img/avatar/1.jpg"
import * as XLSX from "xlsx";

import moment from 'moment';
import CustomModalApproveUser from "../Bar/CustomModalApproveUser";
import CustomModalAttendantUser from "../Bar/CustomModalAttendantUser";

const AttandanceIndex = () => {
  const [state, setState] = useState({
    page: 1,
    data: [],
    data_approve: [],
    users: [],
    total: 0,
    limit: 100,
    s: "",
    apply_leave_reason_id: null,
    apply_leave_status_id: null, // Default null means "All"
    description: null,
    user_data: null,
    update_status_data: {
      id: 0,
      admin_feedback: "",
      apply_leave_status_id: 1
      // 2 approve, 3 reject, 1 pending
    }
  });

  const [selectData, setSelectData] = useState(null); // For modals

  useEffect(() => {
    getAllAttandance();
  }, []);

  const exportUsersToExcelClient = (data, filename) => {
    exportToExcel(data, filename);
  }

  const handleFileUpload = async (event) => {
    // event.preventDefault();
    // let dataExcel = [];

    const file = event.target.files[0];
    if (!file)
      return;
    const reader = new FileReader();

    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array", cellText: false, cellDates: true });

      // Assuming the first sheet is the one you want
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      //filterout 1 row
      const filteredData = jsonData.slice(1);

      let file_data = [];

      filteredData.forEach((data, index) => {
        const date = new Date(data[3]);
        const formattedDate = moment(date).format("YYYY-MM-DD")

        if (data && data.length !== 0) {
          file_data.push({
            first_name: data[0],
            last_name: data[1],
            custom_id: data[2],
            dob: formattedDate,
          })
        }
      });

      try {
        let results = await API.postUser(file_data);
        if (results.result) {
          toast.success("Your action is successful", {
            data: {
              title: "Success toast",
              text: "This is a success message",
            },
          })
        }
        getAllAttandance();

      } catch (error) {
        console.log(error)
      }
    };

    reader.readAsArrayBuffer(file);
  }

  const getAllAttandance = async (statusId, pageNum, search) => {
    const currentStatusId = statusId !== undefined ? statusId : state.apply_leave_status_id;
    const currentPage = pageNum !== undefined ? pageNum : state.page;
    const currentSearch = search !== undefined ? search : state.s;

    try {
      let query = `page=${currentPage}&s=${currentSearch}&limit=${state.limit}`;

      if (currentStatusId) {
        query = `page=${currentPage}&s=${currentSearch}&apply_leave_status_id=${currentStatusId}&limit=${state.limit}`;
      }
      let results = await API.getAllApplyLeave(query);

      let data = results.data;

      setState(prev => ({
        ...prev,
        data: data.apply_leave,
        total: data.total,
        limit: data.limit,
        // Update local state to match parameters used for fetching
        apply_leave_status_id: currentStatusId,
        page: currentPage,
        s: currentSearch
      }));

    } catch (error) {
      console.log(error)
    }
  }

  const onSearch = async (event) => {
    event.preventDefault();
    const s = event.target.value;
    getAllAttandance(undefined, 1, s);
  }

  const onPaginationPress = (page) => {
    getAllAttandance(undefined, page, undefined);
  }

  const deleteUser = async (event) => {
    event.preventDefault();
    let data = {
      user_id: selectData.id
    }
    try {
      let results = await API.postDeleteUser(data);

      if (results.result) {
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        getAllAttandance();
      }

    } catch (error) {
      console.log(error)
    }
  }

  const blockUser = async (event) => {
    event.preventDefault();
    let data = {
      user_id: selectData.id,
      block: selectData.block ? 0 : 1
    }
    try {
      let results = await API.postBlockUser(data);

      if (results.result) {
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        getAllAttandance();
      }

    } catch (error) {
      console.log(error)
    }
  }

  const approveUser = async (event, data) => {
    event.preventDefault();

    // Construct data directly from arguments to avoid stale state issues with nested objects
    const payload = {
      id: state.update_status_data.id,
      admin_feedback: data.admin_feedback,
      apply_leave_status_id: data.apply_leave_status_id
    };

    try {
      let results = await API.postOneApplyLeave(payload);

      if (results.result) {
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        getAllAttandance();
      }

    } catch (error) {
      console.log(error)
    }
  }

  const linkToNewPage = async (id) => {
    let element = document.getElementById(`clickview${id}`);
    if (element) element.click();
  }

  let sort_by = {
    all_users: { name: "All" },
    approve: { name: "Approve" },
    block: { name: "Reject" }
  }

  let displaySort = "All";

  if (state.apply_leave_status_id === 2) {
    displaySort = sort_by.approve.name;
  } else if (state.apply_leave_status_id === 3) {
    displaySort = sort_by.block.name;
  }

  return (
    <div className="col-12 ">
      <ToastContainer />
      <div className="card card-body card-hover-shadow p-40">
        <h4 className="card-title"><strong>Attandance:<b className="text-success fw-500 w-80px"> </b></strong> <i className="fa fa-users"> </i></h4>

        <div className="card-body">

          <div className="flexbox mb-20">
            <div className="lookup">
              <input className="w-250px" type="text" name="s" placeholder="Search" onChange={onSearch} />
            </div>

            <div className="btn-toolbar">
              <div className="btn-group btn-group-sm">
                {/* <Link to="/useredit" > <button className="btn btn-primary" title="Add new" data-provide="tooltip"> <i className="ion-plus-round" ></i></button></Link> */}

                &emsp;<button className="btn btn-info dropdown-toggle" data-toggle="dropdown">Sort By: {displaySort}</button>
                <div className="dropdown-menu dropdown-menu-right">
                  <Link className="dropdown-item" onClick={(e) => {
                    e.preventDefault();
                    getAllAttandance(null, 1, undefined);
                  }}><i className="fa fa-users"></i>All</Link>
                  <Link className="dropdown-item" onClick={(e) => {
                    e.preventDefault();
                    getAllAttandance(2, 1, undefined);
                  }}><i className="fa fa-check"></i>Approved</Link>
                  <Link className="dropdown-item" onClick={(e) => {
                    e.preventDefault();
                    getAllAttandance(3, 1, undefined);
                  }}><i className="fa fa-user-times"></i>Reject</Link>
                </div>

              </div>

              <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">

                {/* <button className="btn btn-info" onClick={(e) => {
                        e.preventDefault()
                        document.getElementById("importExcel").click()
                        }}><i class="fa fa-file-excel-o"></i> Import</button> */}
                <input
                  type="file"
                  accept=".xlsx, .xls"
                  onChange={handleFileUpload}
                  hidden
                  id="importExcel"
                />

                {/* <button className="btn btn-info dropdown-toggle" data-toggle="dropdown">Export</button> */}
                <div className="dropdown-menu dropdown-menu-right">
                  <Link className="dropdown-item" to="#" ><i className="fa fa-file-zip-o"></i> Zip</Link>
                  <Link className="dropdown-item" to="#" ><i className="fa fa-file-pdf-o"></i> PDF</Link>
                  {/* <Link class="dropdown-item" onClick={this.exportToExcel} ><i class="fa fa-file-excel-o"></i> Excel</Link> */}
                  {/* <Link class="dropdown-item" onClick={this.testExport(this.state.users, "user data")} ><i class="fa fa-file-excel-o"></i> Excel</Link> */}
                  <Link className="dropdown-item" onClick={(event) => { exportUsersToExcelClient(state.users, "user data") }} to="#"><i className="fa fa-file-excel-o"></i> Excel</Link>
                </div>
              </div>
            </div>
          </div>
          <div>
          </div>

          <table className="table table-hover table-has-action">
            <thead>
              <tr>
                <th className="text-center w-20px"><h6>#</h6></th>
                <th className="text-center w-40px"><h6>Profile</h6></th>
                <th className="text-center w-180px"><h6>User Name</h6></th>
                <th className="text-center w-180px"><h6>Amount of Days</h6></th>
                <th className="text-center "><h6>Feedback</h6></th>
                <th className="text-center w-200px"><h6>Phone Number</h6></th>
                {/* <th className="text-center w-120px"><h6>Gender</h6></th> */}
                <th className="text-center "><h6>Reason</h6></th>
                <th className="text-center "><h6>Status</h6></th>
                <th className="text-center w-150px"><h6>Date</h6></th>
                <th className="text-center  w-200px "><h6>Actions</h6></th>
              </tr>
            </thead>
            <tbody>
              {
                state.data?.map((data, index) => {

                  let status = data.status;
                  let user = data.user;
                  let reason = data.reason;

                  return <tr key={data.id}>
                    <th onClick={() => linkToNewPage(user.id)} className="text-center w-20px" scope="row"><b>{((state.page - 1) * state.limit) + (index + 1)}</b></th>
                    {/* <td><img style={{width: 30, height: 30, borderRadius: 30}} src={user.profile_url} alt="user profile" /></td> */}
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-40px">
                      <div className="media">
                        {/* <img class="avatar" src={user.profile_url ? user.profile_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." /> */}
                        <img className="avatar" src={user.profile_url ? user.profile_url : img1} alt="..." />
                        <div className="media-body">
                          {/* <p >{video.title_kh}</p> */}
                        </div>
                      </div>
                    </td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-180px"><strong>{user.last_name + ' ' + user.first_name}</strong></td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-200px">{data.nb_days}</td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-200px">{data.admin_feedback}</td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-200px">{user.phone_number}</td>
                    {/* <td className="text-center w-120px">{user.gender_id === 1 ? "Male" : user.gender_id === 2 ? "Female" : "Other"}</td> */}
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-200px">{reason.name}</td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-200px" ><p style={{ background: status.color, color: '#FFFFFF', borderRadius: 25 }}><strong>{status.name}</strong></p></td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-150px">{moment(data.from_date).format("DD-MMM-YYYY")}:{moment(data.to_date).format("DD-MMM-YYYY")}</td>
                    {/* <td className="text-right table-actions"></td> */}
                    <td className="text-center table-actions text-center ">
                      <span>&nbsp;</span><button title="Approve" className="btn btn-square btn-round btn-success" data-toggle="modal" data-target="#modal-center-approveattandantuser" onClick={() => {
                        setState(prev => ({
                          ...prev,
                          update_status_data: { ...prev.update_status_data, id: data.id },
                          user_data: user
                        }));
                      }}><i className="fa fa-check" id={`clickview${user.id}`}></i></button>
                    </td>
                  </tr>
                })
              }
            </tbody>
          </table>
          <Pagination
            onPaginationPress={onPaginationPress}
            totalPageLength={state.total}
            limit={state.limit}
            selectPage={state.page}
          />
        </div>
      </div>
      {
        selectData &&
        <CustomModal
          data={selectData}
          title="Do you really want to delete this user?"
          deleteQuiz={deleteUser}
        />
      }
      {
        selectData &&
        <CustomModalBlockUser
          data={selectData}
          title={selectData.block ? "Do you really want to unblock this user?" : "Do you really want to block this user?"}
          blockUser={blockUser}
          approveUser={approveUser}
        />
      }
      {
        state.user_data &&
        <CustomModalAttendantUser
          data={state.update_status_data}
          user_data={state.user_data}
          title="Please review this user apply leave"
          approveUser={approveUser}
        />
      }
    </div>
  );
}

export default AttandanceIndex;
